var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.2 63",
    style: {
      enableBackground: "new 0 0 65.2 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B6D2F4;}\n\t.st2{opacity:0.1294;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 49.8,
    className: "st0",
    width: 14.9,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,61.6H4.6c-0.2,0-0.4-0.2-0.4-0.4V49.8c0-0.2,0.2-0.4,0.4-0.4h14.9c0.2,0,0.4,0.2,0.4,0.4v11.4 C19.9,61.4,19.7,61.6,19.5,61.6z M5,60.8h14.1V50.2H5V60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 39.2,
    className: "st1",
    width: 14.9,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,61.6H26.6c-0.2,0-0.4-0.2-0.4-0.4v-22c0-0.2,0.2-0.4,0.4-0.4h14.9c0.2,0,0.4,0.2,0.4,0.4v22 C41.9,61.4,41.7,61.6,41.4,61.6z M27,60.8H41V39.6H27V60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 26.1,
    className: "st0",
    width: 14.9,
    height: 35.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,61.6H48.3c-0.2,0-0.4-0.2-0.4-0.4V26.1c0-0.2,0.2-0.4,0.4-0.4h14.9c0.2,0,0.4,0.2,0.4,0.4v35.1 C63.6,61.4,63.4,61.6,63.2,61.6z M48.8,60.8h14.1V26.5H48.8V60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4,60C8.4,60,8.3,60,8.4,60c-1-0.7-1.7-1.4-2.4-2.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0.7,0.8,1.5,1.5,2.3,2.2 c0.1,0,0.1,0.1,0,0.2C8.5,60,8.4,60,8.4,60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6,60C11.5,60,11.5,60,11.6,60c-2-1.7-3.9-3.5-5.7-5.3c-0.1-0.1,0-0.1,0-0.2c0.1-0.1,0.1,0,0.2,0 c1.7,1.9,3.6,3.6,5.6,5.3c0.1,0,0.1,0.1,0,0.2C11.6,60,11.6,60,11.6,60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,60C14.5,60,14.5,60,14.5,60c-2.7-2.5-5.3-5.1-7.8-7.7c-0.1-0.1-0.1-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0 c2.5,2.6,5.1,5.1,7.7,7.6C14.7,59.9,14.7,59.9,14.5,60C14.6,60,14.6,60,14.5,60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,59.8C17.4,59.8,17.4,59.8,17.5,59.8l-8.7-8.3c-0.1-0.1-0.1-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0l8.6,8.3 C17.6,59.7,17.6,59.7,17.5,59.8C17.6,59.8,17.5,59.8,17.5,59.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,57.4C18,57.4,18,57.3,18,57.4c-2.1-2.1-4.1-4-6.2-5.9c-0.1-0.1-0.1-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0 c2.1,1.9,4.2,3.9,6.1,5.9C18.2,57.2,18.2,57.3,18,57.4C18.1,57.3,18.1,57.4,18,57.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.9,54c0,0-0.1,0-0.1,0c-0.9-0.9-1.8-1.8-2.7-2.7c-0.1-0.1-0.1-0.1,0-0.2c0.1-0.1,0.1-0.1,0.2,0 c0.9,0.9,1.9,1.8,2.7,2.7C18,53.9,18,54,17.9,54C17.9,54,17.9,54,17.9,54z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3,59.9c0-0.7,0-1.3,0-2c0-1.6,0.1-3.2,0-4.9c0-1.3,0.1-2.6-0.1-4c-0.2-1.6-0.2-3.2-0.2-4.8c-0.1-2.1-0.2-4.2-0.3-6.3 c-0.1-1.8,0.1-3.6,0.1-5.3c0.1-1.9,0-3.8,0.1-5.7c0.3-1.2-1.4-1.6-1.5-0.3c-0.2,1.6-0.2,3.2-0.3,4.8c-0.1,1.8-0.2,3.5-0.2,5.3 c0,3.1,0.2,6.1,0.1,9.2c0,1.8,0.3,3.5,0.3,5.3c0,1.2,0,2.4,0.1,3.6c0,1.4,0,2.9,0,4.3c0,0.5,0,0.9,0,1.4c0,0.2,0,0.4,0.1,0.6 c0.1,0.4,0.6,0.6,1,0.5C63.4,61.3,63.4,60.5,63.3,59.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4,59.9c-0.3-1.8-0.4-5-0.3-7.4c-0.1-2,0.1-4.1,0-6.1c-0.1-1.6-0.1-3.3-0.1-4.9c0-0.7,0.1-1.3-0.1-2 c-0.3-0.8-1.5-0.5-1.5,0.3c0,3.7,0.1,7.4-0.1,11c0,0.7,0.1,1.5,0.1,2.2c0,1.1-0.1,2.2,0,3.3c0,1.1,0.1,2.2,0.3,3.3 c0,0.4,0,0.8-0.1,1.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0.7,1,1.2,1.5,0.6C41.5,60.9,41.4,60.4,41.4,59.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,60.2c0-0.6,0-1.2,0-1.9c0-2.7-0.1-5.4-0.2-8.2c0-1.1-1.6-1.1-1.6,0c0,2.9,0.1,5.8,0.1,8.7c0,0.5,0,1,0,1.5 c0,0.3,0,0.5,0.1,0.8c0.2,0.6,1.2,0.7,1.5,0.1C19.2,60.9,19.1,60.6,19.1,60.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData1);
export default __webpack_public_path__ + "static/media/noData1.8f266a49993c99256d45c41b7afb100c.svg";
export { ForwardRef as ReactComponent };